import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import org_45authorization_45global from "/vercel/path0/middleware/org-authorization.global.js";
import watchdog_45global from "/vercel/path0/middleware/watchdog.global.js";
export const globalMiddleware = [
  validate,
  org_45authorization_45global,
  watchdog_45global
]
export const namedMiddleware = {}